import { Component, Vue, Prop } from "vue-property-decorator";
import { CarbonSavingsModel } from "../../models/product";
import CarbonSavingsCalculation from "./CarbonSavingsCalculation";

@Component({
    components: {
        CarbonSavingsCalculation
    }
})
export default class CarbonSavingsCalculationContainer extends Vue {
    protected quantity!: number;
    protected calculationCarbonSavingsModel!: CarbonSavingsModel;
    protected isConfigurator!: boolean;
    protected isGDS!: boolean;

    protected created() {
        if (this.$attrs.isgds) {
            this.calculationCarbonSavingsModel = JSON.parse(this.$attrs.calculationcarbonsavingsmodel);
            this.quantity = Number(this.$attrs.quantitydata);
            this.isGDS = this.$attrs.isgds === "true";
            this.isConfigurator = this.$attrs.isconfigurator === "true";
        }
    }
}
